import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SubHead from '../SubHead/SubHead';
import MiniHed from '../SubHead/MiniHed';
import BodyText from '../BodyText/BodyText';
import Button from '../../../common/Button';
import { getFileName, isValid, isText, decodeSpecialCharacters, segmentTrackEvent } from '../../../../utils';
import { appendImgixParamsArticle } from '../../../../imgixUtils';
import './image-module.scss';
import { PinterestShareButton } from 'react-share';

const AmazonProductModule = ({
  data, className, isMobile, additionalClassName, fullUrl=null, articleLayout, isAffiliate, seo
}) => {
  if (!isValid(data)) { return null; }
  const {
    productName,
    productTitle,
    productImageDesktop,
    productImageMobile,
    photoCredit,
    photoCreditUrl,
    imgUrl,
    imageAlt,
    brand,
    bodyText,
    sponsored,
    pinterestProductImageDesktop,
    pinterestProductImageMobile,
  } = data;

  let {
    hidePinterestButton = false,
    price,
    oldPrice,
  } = data;

  oldPrice = isValid(oldPrice) ? `$${oldPrice}` : null;
  price = isValid(price) ? `$${price}` : null;
  const imageSrc = (isMobile && isValid(productImageMobile)) ? productImageMobile : isValid(productImageDesktop) ? productImageDesktop : null;
  const pinterestImageOverride = (isMobile && isValid(pinterestProductImageMobile)) ? pinterestProductImageMobile : isValid(pinterestProductImageDesktop) ? pinterestProductImageDesktop : null;
  const renderedImage = (imageSrc !== null) ? <img className={className} src={imageSrc} alt={isText(imageAlt) ? imageAlt : getFileName(imageSrc)} loading="lazy"/> : null;

  const { buttonText, buttonUrl } = data;
  const button = {
    text: buttonText,
    price,
    oldPrice,
    url: buttonUrl,
  };
  const getIsButton = () => {
    let { text, url } = button;
    if ((isText(text)) && (isText(url))) {
      return true;
    }
    return false;
  };
  const isButton = getIsButton();
  const isStandard = (articleLayout === 'Standard');
  const imageUrl = (isText(imgUrl)) ? decodeSpecialCharacters(imgUrl) : (isButton) ? buttonUrl : null;
  const skimlinksOrNarrativ = ['go.skimresources.com', 'go.redirectingat.com', 'shop-links.co', 'shop-edits.co'];
  const hasSkimlinksOrNarrativ = isText(imageUrl) ? skimlinksOrNarrativ.some(el => imageUrl.includes(el)) : false;
  const productRel = hasSkimlinksOrNarrativ ? 'noopener sponsored' : 'noopener nofollow';
  const renderedButton = (isButton) ? <Button button={button} isStandard={isStandard} sponsoredRel={isButton ? true : false} /> : null;
  const pinMedia = isValid(pinterestImageOverride) ? pinterestImageOverride : imageSrc;
  const showPin = Boolean(fullUrl && pinMedia);

  const credit = isText(photoCredit) ? photoCredit : null;
  // const caption = (imageMobileCaption && isMobile) ? imageMobileCaption : photoCaption;
  const creditUrl = isText(photoCreditUrl) ? photoCreditUrl : null;
  // const captionUrl = (imageMobileCaptionURL && isMobile) ? imageMobileCaptionURL : photoCaptionUrl;

  const containerClassName = isText(additionalClassName) ? `${className}-container ${additionalClassName}` : `${className}-container`;
  const productDataClassName = isStandard ? 'product-data standard' : 'product-data';
  const SubHeadTitleClass = isStandard ? 'sub-head title standard' : 'sub-head title';
  const SubHeadNameClass = isStandard ? 'sub-head name standard' : 'sub-head name';

  if (!renderedImage || !showPin) {
    hidePinterestButton = true;
  }


  return (
    <div className={containerClassName}>
      <div className="image-wrapper">
        {(isText(imageUrl)) ? (
          <a className="large-product-link" href={imageUrl} target="_blank" rel={productRel} data-link-type="image-link" >
            <div className={`img-container-${className}`}>
              {renderedImage}
              { !hidePinterestButton &&
                <div className="social-pin-wrapper">
                  <PinterestShareButton
                    className="social-share-unit pinterest"
                    onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                    url={fullUrl}
                    alt={imageAlt || 'pinterest share image'}
                    description={seo.metaDescription}
                    media={pinMedia || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
                  </PinterestShareButton>
                </div>
                }
              {sponsored && <span className="sponsored-txt">SPONSORED</span>}
            </div>
          </a>
        ) : (
          <div className={`img-container-${className}`}>
            {renderedImage}
            { !hidePinterestButton &&
              <div className="social-pin-wrapper">
                <PinterestShareButton
                  className="social-share-unit pinterest"
                  onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                  url={fullUrl}
                  alt={imageAlt || 'pinterest share image'}
                  description={seo.metaDescription}
                  media={pinMedia || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
                </PinterestShareButton>
              </div>}
            {sponsored && <span className="sponsored-txt">SPONSORED</span>}
          </div>
        )}
        <div className="img-credit-container ">
          {/* {(isText(captionUrl)) ? (
            <a href={captionUrl} className="caption" target="_blank" rel={productRel} data-link-type="caption-link">{caption}</a>
          ) : (
            <span className="caption">{caption}</span>
          )}

          {(caption && credit) && <span className="img-credit"> / </span>} */}

          {(isText(creditUrl)) ? (
            <a href={decodeSpecialCharacters(photoCreditUrl)} className="img-credit" target="_blank" rel={productRel} data-link-type="credit-link" dangerouslySetInnerHTML={ { __html: photoCredit } }></a>
          ) : (
            <span className="img-credit" dangerouslySetInnerHTML={ { __html: credit } }></span>
          )}
        </div>
      </div>
      <div className="image-text-wrapper">
        <div className={productDataClassName}>
            {(isText(productTitle))  &&
              <MiniHed className={SubHeadTitleClass} data={productTitle} isSuperlative={true}/>
            }
            {(isText(productName)) &&
              <SubHead className={SubHeadNameClass} data={productName}/>           
            }
            {(isText(brand)) && 
              <div className="sub-head-wrapper">
                <MiniHed className="sub-head brand" data={brand}/>
              </div>
            }
          </div>
        <BodyText className="body-text" data={bodyText} articleLayout={articleLayout} isAffiliate={isAffiliate}/>
      {renderedButton}
      </div>
    </div>
  );
};

AmazonProductModule.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default AmazonProductModule;
